import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';

import { LogicService } from '../../services/logic.service';
import { EnglishOffline, GameDataInternal, LevelData } from '../../../interfaces/cards.interface';
import { MAX_LEVEL, MAX_LEVEL_UNLOCK, MUSIC, VOICE_SPEED } from '../../helper/constant';
import { MapService } from '../../services/map.service';
// import { TextToSpeech } from '@capacitor-community/text-to-speech';
import * as moment from 'moment';

declare const Phaser: any;
import { SyncDataService } from '../../services/sync-data.service';
import { SpeechService } from '../../services/speech.service';

declare const playSound: any;
let that;
let game;
let emitterWin = new Array(6);
let window_width = 0;
let window_height = 0;
let music;
let soundMute = false;
let mapsProperties;
const numOfFlower = 4;

@Component({
    selector: 'app-win-screen',
    templateUrl: './win-screen.component.html',
    styleUrls: ['./win-screen.component.scss'],
})
export class WinScreenComponent implements OnInit, OnDestroy {
    @Input() win = '';
    @ViewChild('container', {static: true}) container: ElementRef;
    @Input() data: LevelData;
    @Output() reload: EventEmitter<string> = new EventEmitter<string>();
    gameActive = 'lock';
    saveCard = false;
    cardrec: EnglishOffline;
    cardImgDirectory = '../../../assets/english/';
    readingReady = false;
    englishCards: EnglishOffline[] = [];
    wordEnglish = '';
    wordTranslate = '';
    // speechTextInit = new Speech();
    voiceSpeed = VOICE_SPEED.normal;

    constructor(public router: Router,
                public navCtr: NavController,
                public logic: LogicService,
                public mapService: MapService,
                private syncGameDataService: SyncDataService,
                private speechService: SpeechService) {
        that = Object.create(this.constructor.prototype);
    }

    ngOnInit() {
        if (!this.data) {
            return;
        }
        // if (this.mapService.getPlatformIsDesktop()) {
        //     this.speechWordInit();
        // }
        // if (this.platform.is('ios')) {
        //     this.voiceSpeed = VOICE_SPEED.veryHigh;
        // } else {
        //     this.voiceSpeed = VOICE_SPEED.normal;
        // }
        console.log('WIN INIT');
        mapsProperties = this.mapService.getMapsProperties();
        this.gameActive = this.mapService.getGameLock();
        soundMute = this.mapService.getSoundConfig();
        const w = (this.container && this.container.nativeElement && this.container.nativeElement.offsetWidth) ? this.container.nativeElement.offsetWidth : window.innerWidth;
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) {
            window_width = w;
            window_height = Math.round(w * (1079 / 1915));
        } else {
            window_width = w;
            window_height = Math.round(w * 0.5634);
        }
        this.englishCards = this.mapService.getEnglishCards();
        this.saveGameData();
        this.cardrec = this.englishCards.find(it => it.topic === this.data.topic
            && it.level === this.data.level.toString()
            && it.map === this.data.map_id.toString());
        if (this.cardrec) {
            this.wordParse(this.cardrec.word);
        }
        this.readingReady = false;

        let soundPromise: Promise<any>;
        if (!this.mapService.getMusic()) {
            this.mapService.stopMusic();
            soundPromise = this.playSounds(MUSIC.win);
        } else {
            if (this.mapService.getSoundIsPlay() !== MUSIC.win) {
                this.mapService.stopMusic();
                soundPromise = this.playSounds(MUSIC.win);
            } else {
                soundPromise = Promise.resolve(null);
            }
        }

        const triggerSpeech = () => {
            if (this.wordEnglish) {
                this.speechClick(this.wordEnglish);
            }
            this.readingReady = true;
        };

        soundPromise.then((audioObj: any) => {
            if (audioObj) {
                let durationMs = 900;
                if (audioObj.buffer && audioObj.buffer.duration) {
                    durationMs = Math.round(audioObj.buffer.duration * 1000);
                } else if (audioObj.duration) {
                    durationMs = Math.round(audioObj.duration * 1000);
                }
                setTimeout(() => {
                    triggerSpeech();
                }, durationMs + 300);
            } else {
                setTimeout(() => {
                    triggerSpeech();
                }, 400);
            }
        }).catch(() => {
            setTimeout(() => {
                triggerSpeech();
            }, 800);
        });
        const config = {
            width: window_width,
            height: window_height,
            renderer: Phaser.CANVAS,
            parent: 'win',
            state: {
                preload: this.preload,
                create: this.create
            },
            transparent: true
        };

        game = new Phaser.Game(config);
        game.clearBeforeRender = false;
    }

    ngOnDestroy() {
        this.clearAllData();
    }

    clearAllData() {
        console.log('WIN PAGE Clear All Data!');
        if (game) {
            try {
                game.destroy();
            } catch (e) {
                console.log(e);
            }
            game = undefined;
        }
        emitterWin = [];
        music = null;
        mapsProperties = null;
    }

    wordParse(data: string) {
        const word = JSON.parse(data);
        const lang = this.mapService.getLanguage();
        this.wordEnglish = word.en;
        this.wordTranslate = this.wordEnglish;
        Object.keys(word).forEach((key) => {
            if (key === lang) {
                this.wordTranslate = word[key];
            }
        });

    }

    resetGame() {
        this.reload.emit('reload');
    }

    preload() {
        game.load.spritesheet('win-flower', '../../../assets/sprites/hoa.png', 64, 68);
    }

    create() {
        for (let i = 0; i < numOfFlower; i++) {
            emitterWin[i] = game.add.emitter(window_width / (2 * numOfFlower) + i * window_width / numOfFlower, 90 * window_height / 100, 50);
            emitterWin[i].makeParticles('win-flower', [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20], 50, false, true);
            emitterWin[i].gravity = 0;
            emitterWin[i].bounce.setTo(0.5, 0.5);
            emitterWin[i].angularDrag = 60;
            emitterWin[i].maxParticleScale = 0.45;
            emitterWin[i].minParticleScale = 0.15;
            emitterWin[i].setYSpeed(-100, -600);
            // emitterWin[i].width = game.world.width * 1.5;
            emitterWin[i].minRotation = 0;
            emitterWin[i].maxRotation = 40;

            emitterWin[i].start(false, 4000, 100);
        }
    }

    // speechInit(word: string) {
    //     // if (this.mapService.getPlatformIsDesktop()) {
    //     //     this.speechVoice(word);
    //     // } else {
    //         const option = {
    //             text: word,
    //             locale: 'en-US',
    //             rate: this.voiceSpeed
    //         };
    //         // console.log('TTS Option', option.toString());
    //         TextToSpeech.speak(option)
    //             .then(() => {
    //                 // if (this.platform.is('ios')) {
    //                 //     this.voiceSpeed = VOICE_SPEED.normal;
    //                 // } else {
    //                 //     this.voiceSpeed = VOICE_SPEED.slow;
    //                 // }
    //                 this.voiceSpeed = VOICE_SPEED.slow;
    //                 // console.log(`'Success' ${word} 'Speed': ${this.voiceSpeed}`);
    //             })
    //             .catch((reason: any) => {
    //                 console.log('Text to Speech Mobile Error', reason);
    //             });
    //     // }
    // }

    // speechVoice(word: string) {
    //     if (!word) {
    //         return;
    //     }
    //     if (!this.speechTextInit) {
    //         return;
    //     }
    //     this.speechTextInit.speak({
    //         text: word,
    //     }).then(() => {
    //         if (this.platform.is('ios')) {
    //             this.voiceSpeed = VOICE_SPEED.high;
    //         } else {
    //             this.voiceSpeed = VOICE_SPEED.slow;
    //         }
    //         // console.log(`'Success' ${word} 'Speed': ${this.voiceSpeed}`);
    //         // console.log('Success !');
    //     }).catch(() => {
    //         console.error('An error occurred :');
    //     });
    // }

    goNextLevel() {
        if (!this.readingReady) {
            return;
        }
        // that.playSounds(MUSIC.select);
        if (game) {
            try {
                game.destroy();
            } catch (e) {
                console.log(e);
            }
            game = undefined;
        }
        if (music) {
            this.mapService.stopMusic();
        }
        let next_level = 0;
        if (this.gameActive === 'lock' && this.data.level >= MAX_LEVEL_UNLOCK) {
            let page = '';
            if (this.data.map_id === 1) {
                page = 'basic-level';
            } else if (this.data.map_id === 2) {
                page = 'condit-level';
            } else if (this.data.map_id === 3) {
                page = 'func-level';
            } else if (this.data.map_id === 4) {
                page = 'loop-level';
            } else if (this.data.map_id === 5) {
                page = 'sequence-level';
            }
            this.router.navigate([page], {queryParams: {topic: this.data.topic}});
        } else if (this.data.level < MAX_LEVEL) {
            next_level = this.data.level + 1;
            if (next_level > 15 && this.data.page === 'sweet-basic') {
                this.data.page = 'sweet-basic-2';
            }
            if (next_level > 15 && this.data.page === 'env-basic') {
                this.data.page = 'env-basic-2';
            }
            if (next_level > 10 && this.data.page === 'sweet-condition') {
                this.data.page = 'sweet-condition-2';
            }
            if (next_level > 10 && this.data.page === 'env-condition') {
                this.data.page = 'env-condition-2';
            }
            this.router.navigate([this.data.page], {
                queryParams: {
                    level: next_level,
                    currentLevel: this.data.currentLevel,
                    page: this.data.page,
                    topic: this.data.topic
                }
            });
        } else {
            this.data.level = MAX_LEVEL;
            let page = '';
            if (this.data.map_id === 1) {
                page = 'basic-level';
            } else if (this.data.map_id === 2) {
                page = 'condit-level';
            } else if (this.data.map_id === 3) {
                page = 'func-level';
            } else if (this.data.map_id === 4) {
                page = 'loop-level';
            } else if (this.data.map_id === 5) {
                page = 'sequence-level';
            }
            this.router.navigate([page], {queryParams: {topic: this.data.topic}});
        }

    }

    saveGameData() {
        if (this.data.currentLevel > MAX_LEVEL) {
            return;
        }
        if (!this.saveCard) {
            if (this.data.level + 1 > this.data.currentLevel) {
                this.data.currentLevel = this.data.level + 1;
                // this.logic.setDataAfterWin(1, level + 1);
                const gameLevel: GameDataInternal = {
                    gameAddress: this.data.topic + this.data.map_id,
                    currentLevel: this.data.currentLevel,
                    updatedAt: moment()
                };
                this.syncGameDataService.syncGameData(gameLevel, this.data.topic + this.data.map_id);
                // console.log('SaveData', this.data);
            }
            this.saveCard = true;
        } else {
            // console.log('UnSave', this.data);
        }

    }

    playSounds(file: string) {
        return new Promise((resolve, reject) => {
            if (soundMute === true) {
                playSound(file).then((audioObj: any) => {
                    resolve(audioObj);
                }).catch(e => {
                    reject(e);
                });
            } else {
                resolve(null);
            }
        });
    }

    speechClick(word: string) {
        this.speechService.speechText(this.wordEnglish, this.voiceSpeed);
        this.voiceSpeed = VOICE_SPEED.slow;
    }
}
